import { Box, Text } from '@dixa/lib-shared-habla';

import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { useAppSelector } from 'utils/redux/useAppSelector';

import { elevioActions } from '../../../elevio.actions';
import { elevioSelectors } from '../../../elevio.reducer/selectors';

import { ArticleOrDraftSelector } from './ResolutionModalBody';
import styles from './ResolutionModalBody.module.scss';

import { ResolutionRadioInputs } from './index';

export function ResolutionArticleSolveDialog(): JSX.Element {
  const dispatch = useAppDispatch();
  const articleSolved = useAppSelector(
    elevioSelectors.resolution.articleSolved,
  );
  const searchInputValue = useAppSelector(
    elevioSelectors.search.searchInputValue,
  );

  const yesChecked = articleSolved === true;
  const noChecked = articleSolved === false;

  const onCheckYes = () =>
    dispatch(elevioActions.resolution.setSolution({ searchInputValue }));
  const onCheckNo = () => dispatch(elevioActions.resolution.setNoSolution());

  return (
    <>
      <Box className={styles.section}>
        <Text.Paragraph subdued={true} className={styles.paragraph}>
          Did an article solve this user&apos;s issue?
        </Text.Paragraph>
        <ResolutionRadioInputs
          name="articleSolved"
          noChecked={noChecked}
          onCheckNo={onCheckNo}
          onCheckYes={onCheckYes}
          yesChecked={yesChecked}
        />
      </Box>
      <ArticleOrDraftSelector />
    </>
  );
}
